'use strict';

var index = require('../../../../../../../_virtual/index7.cjs');

var hasRequiredProRegularSvgIcons;

function requireProRegularSvgIcons () {
	if (hasRequiredProRegularSvgIcons) return index.__exports;
	hasRequiredProRegularSvgIcons = 1;

	/*!
	 * Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com
	 * License - https://fontawesome.com/license (Commercial License)
	 * Copyright 2024 Fonticons, Inc.
	 */
	const faCircleExclamation = {
	  prefix: 'far',
	  iconName: 'circle-exclamation',
	  icon: [512, 512, ["exclamation-circle"], "f06a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
	};
	const faExclamationCircle = faCircleExclamation;
	const faBan = {
	  prefix: 'far',
	  iconName: 'ban',
	  icon: [512, 512, [128683, "cancel"], "f05e", "M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L419.1 385.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
	};
	const faClock = {
	  prefix: 'far',
	  iconName: 'clock',
	  icon: [512, 512, [128339, "clock-four"], "f017", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
	};

	index.__exports.faBan = faBan;
	index.__exports.faCircleExclamation = faCircleExclamation;
	index.__exports.faClock = faClock;
	index.__exports.faExclamationCircle = faExclamationCircle;
	
	return index.__exports;
}

exports.__require = requireProRegularSvgIcons;
//# sourceMappingURL=index.cjs.map
